import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { RadioButton } from "components";
import { ACHProcessorData } from "globalConstants";

import styles from "./../formSections.module.scss";

const WhoAreYourCustomers = () => (
	<Row className="mb-4">
		<Col>
			<div className={styles.inlineItemsHeader}>
				{ACHProcessorData.CustomerType.displayName}
			</div>
			<div className={styles.inlineItems}>
				<Field
					component={RadioButton}
					value={ACHProcessorData.CustomerType.Individuals.value}
					className={styles.item}
					name={ACHProcessorData.CustomerType.name}
					label={
						ACHProcessorData.CustomerType.Individuals.displayName
					}
					type="radio"
					id={`wayc-${ACHProcessorData.CustomerType.Individuals.value}`}
				/>
				<Field
					component={RadioButton}
					value={ACHProcessorData.CustomerType.Businesses.value}
					className={styles.item}
					name={ACHProcessorData.CustomerType.name}
					label={ACHProcessorData.CustomerType.Businesses.displayName}
					type="radio"
					id={`wayc-${ACHProcessorData.CustomerType.Businesses.value}`}
				/>
				<Field
					component={RadioButton}
					value={ACHProcessorData.CustomerType.Both.value}
					className={styles.item}
					name={ACHProcessorData.CustomerType.name}
					label={ACHProcessorData.CustomerType.Both.displayName}
					type="radio"
					id={`wayc-${ACHProcessorData.CustomerType.Both.value}`}
				/>
			</div>
		</Col>
	</Row>
);

export default memo(WhoAreYourCustomers);
